import { render } from "./InviteLinkModal.vue?vue&type=template&id=2f047e66&scoped=true"
import script from "./InviteLinkModal.vue?vue&type=script&lang=js"
export * from "./InviteLinkModal.vue?vue&type=script&lang=js"

import "./InviteLinkModal.vue?vue&type=style&index=0&id=2f047e66&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f047e66"]])

export default __exports__